const mutations = {
  mutationPolicies(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.policies[payload.tab] = payload.responseData;
    } else {
      state.policies = payload;
    }
  },

  mutationPolicy(state, payload) {
    state.policy = payload;
  },

  mutationClaims(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.claims[payload.tab] = payload.responseData;
    } else {
      state.claims = payload;
    }
  },

  mutationClaim(state, payload) {
    state.claim = payload;
  },

  mutationPoliciesMeta(state, payload) {
    state.policiesMeta = payload;
  },

  mutationClaimsMeta(state, payload) {
    state.claimsMeta = payload;
  },

  mutationListClaimsHistoriesPolicy(state, payload) {
    state.claimsHistoriesPolicy = payload;
  },

  mutationListClaimsHistoriesClaim(state, payload) {
    state.claimsHistoriesClaim = payload;
  },

  mutationPartners(state, payload) {
    state.partners = payload;
  },

  mutationProducts(state, payload) {
    state.products = payload;
  },

  mutationProductCategories(state, payload) {
    state.productCategories = payload;
  },

  mutationUploadProgress(state, payload) {
    state.uploadProgress = payload;
  },

  mutationGetTemplateUrl(state, payload) {
    state.templateUrl = payload;
  },
};

export default mutations;
